module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum01-df4799eafea5336d396c7189dece4a33.png";